"use client";

import { Sub } from "@radix-ui/react-dropdown-menu";
import React from "react";
import { splitBreakpointProps } from "@/lib/utils";
import type { DropdownMenuSubProps } from "../types";

function DropdownMenuSub({ ...props }: DropdownMenuSubProps) {
  const { native } = splitBreakpointProps(props);

  return <Sub data-slot="dropdown-menu-sub" {...native} />;
}

DropdownMenuSub.displayName = "DropdownMenu.Sub";

export default DropdownMenuSub;
